import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import type { AtlasQueryContext } from "@/lib/query-client";

export function AtlasDataProvider({
  children,
  queryClient,
}: AtlasQueryContext & { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
